// extracted by mini-css-extract-plugin
export default {"keyText":"ServiceKeysCell_keyText__FVrxu","copyButton":"ServiceKeysCell_copyButton__1Toa_","emptyState":"ServiceKeysCell_emptyState__1WAkn"};